import React, { useState } from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { customerFocusSalesHistorySelectAmount } from '../../../actions';

const AmountFilter = ({placeholder}) => {
    const dispatch = useDispatch()
    const { amountSalesHistorySelected } = useSelector(({customerFocus}) => customerFocus)
    const [selected, setSelected] = useState(amountSalesHistorySelected);
    const { langMaster } = useSelector(({i18nMaster}) => i18nMaster);

    const data = [
        { value: 'amount', label: `${langMaster.amount}` },
        { value: 'qty', label: `${langMaster.quantity}` }
    ];
    
    const handleChange = (selected) => {
        setSelected(selected)
        dispatch(customerFocusSalesHistorySelectAmount(selected))
    }

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 9999
        }),
    }

    return(
        <Select
            styles={customStyles}
            value={data.find(d => d.value === selected?.value) || null}
            onChange={handleChange}
            options={data}
            placeholder={placeholder}
            />
    );
}

export default AmountFilter;